import {
  Button,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { Search as SearchIcon } from "@material-ui/icons";
import { sortBy, isEmpty, isString } from "lodash";
import ReactCountryFlag from "react-country-flag";
import { useSelector } from "react-redux";
import "../style.css";
import { useTranslation } from "react-i18next";

const DialCodeView = ({
  onChangeDialCode,
  setShowDialCodeView,
  countries = [],
}) => {
  const { t } = useTranslation();

  const [searchNeedle, setSearchNeedle] = useState("");

  const filteredCountries = React.useMemo(() => {
    let validCountries = sortBy(
      countries.filter((current) => !isEmpty(current.dialCode)),
      ["name"]
    );
    if (isString(searchNeedle) && !isEmpty(searchNeedle)) {
      const needle = searchNeedle.toLowerCase();
      validCountries = validCountries.filter((current) => {
        return ["name", "dialCode"].some((key) =>
          current[key].toLowerCase().includes(needle)
        );
      });
    }
    return validCountries;
  }, [searchNeedle, countries]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      className="dial-code-selector-section row-gap-16"
    >
      <Grid container direction="column" className="content-contaier">
        <TextField
          variant="outlined"
          focused={true}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
          className="search-text"
          value={searchNeedle}
          onChange={(e) => {
            setSearchNeedle(e.target.value);
          }}
        />
        <Grid container direction="column" className="dial-code-list">
          {filteredCountries.map((current) => (
            <Grid
              key={current.code}
              item
              container
              direction="row"
              justifyContent="space-between"
              className="list-item"
              onClick={() => {
                onChangeDialCode(current);
              }}
            >
              <Grid
                item
                xs
                container
                direction="row"
                alignItems="center"
                style={{ columnGap: 8, flexWrap: "nowrap" }}
              >
                <ReactCountryFlag countryCode={current.code} svg />
                <Typography className="list-item-txt">
                  {current.name}
                </Typography>
              </Grid>
              <Typography className="list-item-txt">
                {current.dialCode}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Button
        variant="outlined"
        fullWidth
        className="back-btn"
        onClick={() => setShowDialCodeView(false)}
      >
        {t("common.backBtnText")}
      </Button>
    </Grid>
  );
};

export default DialCodeView;
